import React from "react";
import styles from './TitleContainer.module.scss';

interface IProps {
    file: string
}

export default function TitleContainer(props: IProps) {

    return (
        <div className={styles["title-container"]}>
            <img src={require( ''+props.file).default} alt="Title" />
        </div>
    )
}